export default __webpack_public_path__ + "static/media/check.eba50bdd.svg";